/**
 * @fileoverview The common "View Step" button shared across the section tables.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {Button} from '/ui/components/button/button';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/summary.module.scss';

/**
 * @param {{
 *   onClick: function(): void,
 * }} props
 * @returns {React.ReactNode}
 */
export function ViewStepButton({
  onClick,
}) {
  return (
    <div className={styles.buttonContainer}>
      <Button onClick={onClick}>
        {yext.msg('View Step')}
      </Button>
    </div>
  );
}
